export default __webpack_public_path__ + "static/media/hatred.af825aa3.svg";